import '../../../styles/flashcards/FlashcardItem.css';

import {
	FaAngleDoubleLeft,
	FaAngleDoubleRight,
	FaArrowLeft,
	FaArrowRight,
	FaChevronLeft,
	FaChevronRight,
} from 'react-icons/fa';
import { MathJax, MathJaxContext } from 'better-react-mathjax';
import React, { useEffect, useRef, useState } from 'react';
import { SlArrowLeft, SlArrowRight } from 'react-icons/sl';

import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import BackArrow from '../../../assets/back-arrow.svg';
import { getFlashcardDetails } from '../../../services/DashboardApi.js';
import { logger } from '../../../utils/logger';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import userIcon from '../../../assets/user_profile.svg';

//import { handleSubTabClick } from "../../../components/templates/knowledge-concept/KnowledgeConceptHeader.jsx";

const Flashcard = () => {
	//const [flashcards, setFlashcards] = useState([{ id: Date.now(), content: "This is a dummy flashcard." }]);
	//const [flashcards, setFlashcards] = useState([]);
	const [currentIndex, setCurrentIndex] = useState(0);
	const navigate = useNavigate();
	const { topicId, subtopicId, subject, userId, flashcardId } = useParams();
	const [flashcard_data, setFlashcardData] = useState([]);
	const [isFlipped, setIsFlipped] = useState(false);
	const { firstName } = useSelector((state) => state.userDetails);
	const [slideDirection, setSlideDirection] = useState(''); // NEW
	const flashcardRef = useRef(null);
	const textRef = useRef(null);
	const [isOverflowing, setIsOverflowing] = useState(false);

	useEffect(() => {
		const fetchFlashcardDetails = async (userId, subject, topicId, subtopicId) => {
			try {
				subject = subject === 'MATH' ? 'MATHS' : subject;
				const response = await getFlashcardDetails(
					userId,
					subject,
					topicId,
					subtopicId,
					flashcardId
				);
				logger.log('getFlashcardDetails response: ', response.data);
				setFlashcardData([]);
				if (response.data && response.data.length > 0) {
					const formattedData = response.data.flatMap((fc) =>
						fc.FLASHCARDS_CONTENT.map((contentItem) => ({
							front: contentItem.question,
							back: contentItem.answer,
							type: contentItem.type,
						}))
					);

					setFlashcardData(formattedData); // Update state with the entire mapped array at once
				}
			} catch (err) {
				logger.log('Error while fetching flashcard details: ', err);
			}
		};
		fetchFlashcardDetails(userId, subject, topicId, subtopicId);
	}, [userId, subject, topicId, subtopicId]);

	useEffect(() => {
		requestAnimationFrame(() => {
			if (textRef.current) {
				const height = textRef.current.offsetHeight;
				const lineHeight = parseInt(getComputedStyle(textRef.current).lineHeight, 10) || 24;
				const numLines = height / lineHeight;
				setIsOverflowing(numLines > 6); // Adjust 6 to define when it's "long"
			}
		});
	}, [currentIndex, isFlipped]);

	// const handleNext = () => {
	//   if (currentIndex < flashcard_data.length - 1) {
	//     setCurrentIndex((prevIndex) => prevIndex + 1);
	//   }
	// };

	// const handlePrevious = () => {
	//   if (currentIndex > 0) {
	//     setCurrentIndex((prevIndex) => prevIndex - 1);
	//   }
	// };
	const handleNext = () => {
		if (currentIndex < flashcard_data.length - 1) {
			setSlideDirection('right');
			setCurrentIndex((prevIndex) => prevIndex + 1);
			resetFlip();
		}
	};

	const handlePrevious = () => {
		if (currentIndex > 0) {
			setSlideDirection('left');
			setCurrentIndex((prevIndex) => prevIndex - 1);
			resetFlip();
		}
	};

	const handleSkipToFirst = () => {
		setCurrentIndex(0);
		resetFlip();
		setSlideDirection('left');
	};

	const handleSkipToLast = () => {
		setCurrentIndex(flashcard_data.length - 1);
		resetFlip();
		setSlideDirection('right');
	};

	const handleBackArrowClick = () => {
		logger.log('Back Arrow Clicked');
		//handleSubTabClick('Flashcards');
		navigate(`/knowledge_concept`, { state: { selectedSubTab: 'Flashcards' } });
	};

	const handleFlip = () => {
		setIsFlipped(!isFlipped);
	};

	const resetFlip = () => {
		const card = flashcardRef.current;
		if (card) {
			card.style.transition = 'none';
			card.classList.remove('flipped');
			requestAnimationFrame(() => {
				card.style.transition = 'transform 0.6s';
			});
		}
		setIsFlipped(false);
	};

	logger.log('Flashcard data: ', flashcard_data);
	return (
		<div className="flashcard-item-container">
			<img
				src={BackArrow}
				alt="BackArrow"
				width="50"
				height="50"
				className="back-arrow-btn"
				onClick={() => handleBackArrowClick()}
			/>
			{flashcard_data.length > 0 && (
				<div
					className={`flashcard-item ${isFlipped ? 'flipped' : ''} ${
						slideDirection === 'left'
							? 'slide-in-left'
							: slideDirection === 'right'
							? 'slide-in-right'
							: ''
					}`}
					ref={flashcardRef}
					onClick={() => setIsFlipped(!isFlipped)}
					onAnimationEnd={() => setSlideDirection('')}
				>
					<MathJaxContext>
						<React.Fragment>
							<div className="flashcard-content">
								{/* {!isFlipped ? <h2>Flashcard</h2> : <h2></h2>} */}

								<MathJax>
									{flashcard_data[currentIndex]?.content?.type ===
										'AI Generated' && (
										<div className="ai-label-container">
											<AutoAwesomeIcon className="ai-icon" />
											<span className="ai-text">AI generated</span>
										</div>
									)}
									{flashcard_data[currentIndex]?.content?.type ===
										'Self Created' && (
										<div className="ai-label-container">
											<img
												src={userIcon}
												alt="icon"
												className="user-profile-icon"
											/>
											<span className="ai-text">{firstName}</span>
										</div>
									)}
									<div className="flashcard-inner">
										{!isFlipped ? (
											<React.Fragment>
												<h2>Flashcard</h2>
												<div className="flashcard-item-front">
													<div className="flashcard-item-text">
														{flashcard_data[currentIndex]?.front || ''}
													</div>
												</div>
											</React.Fragment>
										) : (
											<React.Fragment>
												<h2
													style={{
														transform: 'rotateY(180deg)',
														paddingRight: '10%',
														paddingLeft: '7%',
													}}
												>
													Flashcard
												</h2>
												<div
													className="flashcard-item-back"
													style={{
														paddingTop: isOverflowing ? '2%' : '10%',
													}}
												>
													<div
														className="flashcard-item-text"
														ref={textRef}
														dangerouslySetInnerHTML={{
															__html:
																flashcard_data[currentIndex]
																	?.back || '',
														}}
													/>
												</div>
											</React.Fragment>
										)}
									</div>
								</MathJax>
							</div>
							{/* </div> */}
						</React.Fragment>
					</MathJaxContext>
				</div>
			)}

			<div className="navigation-flashcard-item">
				<FaAngleDoubleLeft
					className={`nav-icon-flashcard-item ${currentIndex === 0 ? 'disabled' : ''}`}
					onClick={currentIndex === 0 ? null : handleSkipToFirst}
				/>
				<FaChevronLeft
					className={`nav-icon-flashcard-item ${currentIndex === 0 ? 'disabled' : ''}`}
					onClick={handlePrevious}
				/>
				<span>
					{currentIndex + 1}/{flashcard_data.length}
				</span>
				<FaChevronRight
					className={`nav-icon-flashcard-item ${
						currentIndex === flashcard_data.length - 1 ? 'disabled' : ''
					}`}
					onClick={handleNext}
				/>
				<FaAngleDoubleRight
					className={`nav-icon-flashcard-item ${
						currentIndex === flashcard_data.length - 1 ? 'disabled' : ''
					}`}
					onClick={currentIndex === flashcard_data.length - 1 ? null : handleSkipToLast}
				/>
			</div>
		</div>
	);
};

export default Flashcard;
